import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Link } from "react-router-dom";
import { useCookieConsent } from "@/hooks/useCookieConsent";
import { useEffect, useState } from "react";

interface CookieConsentCheckboxProps {
  onConsentChange?: (accepted: boolean) => void;
}

export const CookieConsentCheckbox = ({ onConsentChange }: CookieConsentCheckboxProps) => {
  const { consentStatus, acceptAll, refuseAll } = useCookieConsent();
  const [checked, setChecked] = useState(consentStatus === 'accepted');

  useEffect(() => {
    setChecked(consentStatus === 'accepted');
  }, [consentStatus]);

  const handleChange = (value: boolean) => {
    setChecked(value);
    if (value) {
      acceptAll();
    } else {
      refuseAll();
    }
    onConsentChange?.(value);
  };

  return (
    <div className="flex items-start space-x-2">
      <Checkbox
        id="cookie-consent"
        checked={checked}
        onCheckedChange={handleChange}
        className="mt-0.5"
      />
      <Label 
        htmlFor="cookie-consent" 
        className="text-sm text-muted-foreground leading-tight cursor-pointer"
      >
        Accepter les cookies analytiques.{" "}
        <Link 
          to="/legal" 
          className="text-primary hover:underline" 
          target="_blank"
          onClick={(e) => e.stopPropagation()}
        >
          En savoir plus
        </Link>
      </Label>
    </div>
  );
};
